import {
  HomeOutlined as HomeIcon,
  PeopleOutlined as BeneficiariesIcon,
  TheatersOutlined as ProductionsIcon,
  CategoryOutlined as CategoriesIcon,
  MonetizationOnOutlined as ExpensesIcon,
  SettingsOutlined as ParametersIcon,
  BarChartOutlined as ReportsIcon,
  AssignmentOutlined as ProductionStatusIcon,
  CompareOutlined as ProjectionsIcon,
  // Additional icons for better differentiation
  ReceiptOutlined as ExpenseItemsIcon,
  PaymentOutlined as PaymentTypeIcon,
  TableChartOutlined as ProductionStatusV2Icon,
  ViewModuleOutlined as ProductionStatusV3Icon,
  // SwapHorizOutlined as ProductionStatusV4Icon,
  AttachMoneyOutlined as ProductionStatusV5Icon,
  TrendingUpOutlined as ProfitIcon,
  TrendingDownOutlined as LossIcon,
  // Report icons
  // PeopleOutlined as BeneficiaryAnalysisIcon,
  // TheatersOutlined as EpisodeCostIcon,
  // AssessmentOutlined as BudgetVarianceIcon,
  // TimelineOutlined as ExpenseTimelineIcon,
  CategoryOutlined as CategoryPerformanceIcon,
  LockOutlined as LockedEpisodesIcon,
  DescriptionOutlined as InvoiceTrackingIcon,
  CompareArrowsOutlined as ProductionComparisonIcon,
  WorkOutlineOutlined as ExpenseWorkflowIcon,
} from "@mui/icons-material";

const menuItems = [
  {
    title: "Dashboard",
    to: "/dashboard",
    icon: <HomeIcon />,
  },
  {
    title: "Συναλλ/νοι",
    to: "/beneficiaries",
    icon: <BeneficiariesIcon />,
  },
  {
    title: "Παραγωγές",
    icon: <ProductionsIcon />,
    submenuItems: [
      {
        title: "Παραγωγές",
        to: "/productions/",
        icon: <ProductionsIcon />,
      },
      {
        title: "Είδη Δαπάνης",
        to: "/category_item/",
        icon: <ExpenseItemsIcon />,
      },
      {
        title: "Εγγραφές",
        to: "/recordings/",
        icon: <ProductionsIcon />,
      },
    ],
  },
  {
    title: "Έξοδα",
    to: "/expenses/",
    icon: <ExpensesIcon />,
  },
  {
    title: "Παράμετροι",
    icon: <ParametersIcon />,
    submenuItems: [
      {
        title: "Kατηγορίας",
        to: "/category_type/",
        icon: <CategoriesIcon />,
      },
      {
        title: "Τύπος αμοιβής",
        to: "/category_item_type/",
        icon: <PaymentTypeIcon />,
      },
    ],
  },
  {
    title: "Αναφορές",
    icon: <ReportsIcon />,
    submenuItems: [
      // {
      //   title: "Παραγωγή (v1)",
      //   to: "/production_status/",
      //   icon: <ProductionStatusIcon />,
      // },
      // {
      //   title: "Παραγωγή (v2)(Σελίδες)",
      //   to: "/production_status-2/",
      //   icon: <ProductionStatusV2Icon />,
      // },
      // {
      //   title: "Παραγωγή (v3)(Καρτέλες)",
      //   to: "/production_status-3/",
      //   icon: <ProductionStatusV3Icon />,
      // },
      // {
      //   title: "Παραγωγή (v4)(Μόνο Κόστος)",
      //   to: "/production_status_only/",
      //   icon: <ProductionStatusV5Icon />,
      // },
      {
        title: "Παραγωγή (v1)",
        to: "/production_status-6/",
        icon: <ProductionStatusV3Icon />,
      },
      {
        title: "Παραγωγή (v2)",
        to: "/production_status-5/",
        icon: <ProductionStatusV3Icon />,
      },      
      // {
      //   title: "Παραγωγή (v4)(Αναστροφή)",
      //   to: "/production_status-4/",
      //   icon: <ProductionStatusV4Icon />,
      // },
      {
        title: "Προβλεπόμενο vs Πραγματικό",
        to: "/projections_vs_actual/",
        icon: <ProjectionsIcon />,
      },
      // {
      //   title: "Προβλεπόμενο Κόστος Ετήσιο",
      //   to: "/productions_status_yearly/",
      //   icon: <YearlyReportIcon />,
      // },
      {
        title: "Επικερδείς Δαπάνες",
        to: "/top_ten_items_profit/",
        icon: <ProfitIcon />,
      },
      {
        title: "Ζημιογόνες Δαπάνες",
        to: "/top_ten_items_loss/",
        icon: <LossIcon />,
      },
      // {
      //   title: "Ανάλυση Συναλλασσομένων",
      //   to: "/reports/beneficiary-analysis/",
      //   icon: <BeneficiaryAnalysisIcon />,
      // },
      // {
      //   title: "Ανάλυση Κόστους Επεισοδίων",
      //   to: "/reports/episode-cost-analysis/",
      //   icon: <EpisodeCostIcon />,
      // },
      // {
      //   title: "Απόκλιση Προϋπολογισμού",
      //   to: "/reports/budget-variance/",
      //   icon: <BudgetVarianceIcon />,
      // },
      // {
      //   title: "Χρονοδιάγραμμα Εξόδων",
      //   to: "/reports/expense-timeline/",
      //   icon: <ExpenseTimelineIcon />,
      // },
      {
        title: "Απόδοση Κατηγοριών",
        to: "/reports/category-performance/",
        icon: <CategoryPerformanceIcon />,
      },
      {
        title: "Κλειδωμένα Επεισόδια",
        to: "/reports/locked-episodes/",
        icon: <LockedEpisodesIcon />,
      },
      {
        title: "Παρακολούθηση Τιμολογίων",
        to: "/reports/invoice-tracking/",
        icon: <InvoiceTrackingIcon />,
      },
      {
        title: "Σύγκριση Παραγωγών",
        to: "/reports/production-comparison/",
        icon: <ProductionComparisonIcon />,
      },
      {
        title: "Ροή Εξόδων",
        to: "/reports/expense-workflow/",
        icon: <ExpenseWorkflowIcon />,
      },
    ],
  },
];

export default menuItems;
